import * as React from 'react';

import { Icon, Tooltip, TooltipPlacement } from 'farmhub-ui-core';
import isEqual from 'lodash/isEqual';
import { Maximize } from 'lucide-react';

import { NameText } from 'components';
import NewFeatureTag from 'components/Tag/NewFeatureTag';
import { genMenuIcon } from 'containers/App/utils/function';

import { CBadge, Wrapper, WrapperQuantity } from './styles';

interface MenuItemProps {
  isToggle: boolean;
  menuItem: any;
  menuActive: string;
  onClick: (e: any) => void;
}

const MenuItem = ({
  isToggle,
  menuItem,
  menuActive,
  onClick,
}: MenuItemProps): JSX.Element => {
  const [isDisplay, setIsDisplay] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (isToggle) {
      setTimeout(() => {
        setIsDisplay(isToggle);
      }, 250);
    } else {
      setIsDisplay(isToggle);
    }
  }, [isToggle]);

  return (
    <Tooltip
      placement={TooltipPlacement.Right}
      title={!isToggle && `${menuItem.name}`}
    >
      <Wrapper
        key={menuItem.link}
        active={menuActive === menuItem.link}
        isToggle={isToggle}
        onClick={e => {
          !menuItem.disabled && onClick(e);
        }}
      >
        {genMenuIcon(menuItem.name)}
        {isToggle && (
          <NameText
            className="textMenu"
            style={{ marginLeft: 8 }}
            weight="bold"
          >
            {menuItem.name}
          </NameText>
        )}
        {menuItem?.isBeta && isToggle && (
          <WrapperQuantity isDisplay isToggle={isToggle}>
            <NewFeatureTag text="Beta" />
          </WrapperQuantity>
        )}
        {menuItem?.tag && isToggle && (
          <WrapperQuantity isDisplay isToggle={isToggle}>
            <NewFeatureTag text={menuItem?.tag} />
          </WrapperQuantity>
        )}
        {!menuItem?.tag && menuItem?.isExpand && isToggle && (
          <WrapperQuantity isDisplay isToggle={isToggle}>
            <Tooltip title="Mở rộng toàn màn hình">
              <Maximize strokeWidth={1.5} style={{ width: 14, height: 14 }} />
            </Tooltip>
          </WrapperQuantity>
        )}
        {!menuItem?.isBeta && isDisplay && (
          <WrapperQuantity isDisplay={isDisplay} isToggle={isToggle}>
            <CBadge count={menuItem.quantity} styles={{ fontSize: 11 }} />
          </WrapperQuantity>
        )}
      </Wrapper>
    </Tooltip>
  );
};

function areEqual(prevProps, nextProps) {
  return isEqual(
    {
      isToggle: prevProps.isToggle,
      menuItem: prevProps.menuItem,
      menuActive: prevProps.menuActive,
    },
    {
      isToggle: nextProps.isToggle,
      menuItem: nextProps.menuItem,
      menuActive: nextProps.menuActive,
    }
  );
}

export default React.memo(MenuItem, areEqual);
